import { ApiClientService, EntityApiService } from '@dofleini/security';
import { authentication } from '@/settings';

class TermsApiService extends EntityApiService {
  getCurrent = () =>
    ApiClientService.get(this.getPath('/current'), {}).then((r) => (r && r.data !== undefined ? r.data : r));

  accept = (version) =>
    ApiClientService.post(this.getPath('/accept'), { version }).then((r) => (r && r.data !== undefined ? r.data : r));
}

export default new TermsApiService(`${authentication.path}/api/terms`);
